const ICONS = {
  '主日讲道': 'icon-podium',
  '福音证道': 'icon-bible',
  '福音慕道': 'icon-prayer',
  '婚姻家庭': 'icon-house',
  '赞美敬拜': 'icon-microphone',
  '福音视频': 'icon-television',
  '福音动漫': 'icon-mickey',
  '圣乐教室': 'icon-headset',
  '初信造就': 'icon-class',
  '神学课程': 'icon-podium',
  '福音见证': 'icon-parenting'
}

export const icon = function (value) {
  return ICONS[value]
}

export const n2 = function (value) {
  if (value < 10) {
    return '0' + value
  } else {
    return value
  }
}

export const date = function (value) {
  let dt = new Date(value * 1000)
  return dt.getFullYear() + '-' + n2(dt.getMonth() + 1) + '-' + n2(dt.getDate())
}

export const datetime = function (value) {
  let dt = new Date(value * 1000)
  return dt.getFullYear() + '-' + n2(dt.getMonth() + 1) + '-' + n2(dt.getDate()) + ' ' + n2(dt.getHours()) + ':' + n2(dt.getMinutes())
}

export const datetime2 = function (value) {
  let dt = new Date(value * 1000)
  return n2(dt.getMonth() + 1) + '-' + n2(dt.getDate()) + ' ' + n2(dt.getHours()) + ':' + n2(dt.getMinutes())
}

export const seconds = function (seconds) {
  let minutes = parseInt(seconds / 60)
  let hours = parseInt(minutes / 60)
  seconds = seconds % 60
  minutes = minutes % 60
  if (hours > 0) {
    return n2(hours) + ':' + n2(minutes) + ':' + n2(seconds)
  } else {
    return n2(minutes) + ':' + n2(seconds)
  }
}

export function unit(value) {
  if (value > 10000) {
    let suffix = ''
    value = value / 10000
    suffix = '万'
    if (value > 10000) {
      value = value / 10000
      suffix = '亿'
    }
    return value.toFixed(1) + suffix
  } else {
    return value
  }
}

export default {
  install(Vue) {
    Vue.filter('icon', icon)
    Vue.filter('date', date)
    Vue.filter('datetime', datetime)
    Vue.filter('datetime2', datetime2)
    Vue.filter('seconds', seconds)
    Vue.filter('unit', unit)
  }
}



// WEBPACK FOOTER //
// ./src/util/filters.js